<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions">
      <router-link class="btn btn-success" :to="{ name: 'barcode_range_create' }" tag="button">{{
        'routes_barcode_ranges_create' | t
      }}</router-link>
    </div>
    Create
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      barcode_ranges: []
    };
  },
  methods: {},
  mounted: function () {
    this.setBreadcrumbs([{ to: { name: 'barcode_ranges' }, text: 'Global barcode ranges' }]);
    Api.findAll('barcode_ranges').then(({ data }) => {
      this.barcode_ranges = data;
    });
  }
};
</script>

<style scoped></style>
